import React, { useEffect, useState } from 'react'
import { Row, Col, Button, Nav } from 'react-bootstrap'
import styles from './AnalyticsPaywall.module.css'
import { analyticFeatures, trackedFeatures } from 'constants'
import { addUpgradeReason } from 'utils/general'

const AnalyticsPaywall = ({ onUpgrade, onClose }) => {
  const [activeTab, setActiveTab] = useState('analytics')

  const content = {
    analytics: {
      titlePrefix: 'Upgrade to unlock',
      titleHighlight: 'Project Analytics',
      gifSrc: '/assets/img/gifs/analytics.gif',
      desc: 'Get to know everything about your audience',
      features: analyticFeatures
    },
    tracked: {
      titlePrefix: 'Upgrade to unlock',
      titleHighlight: 'Tracked Links',
      gifSrc: '/assets/img/gifs/tracked-links.gif',
      desc: 'Get notified when someone clicks on your link',
      features: trackedFeatures
    }
  }

  const current = content[activeTab]

  useEffect(() => {
    addUpgradeReason(activeTab === 'tracked' ? 'View Tracked Links' : 'View Analytics')
  }, [activeTab])

  return (
    <div className={styles.paywallContainer}>
      {/* Mobile Header */}
      <div className="d-flex d-md-none justify-content-between align-items-center pt-3 px-4 pb-0">
        <h3 className={styles.proTitle}>Unlock More features</h3>
        {onClose && (
          <div
            role="button"
            onClick={onClose}
            style={{ cursor: 'pointer' }}
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') onClose()
            }}
          >
            <img src="/assets/icons/x-mark.svg" alt="Close" width="24" />
          </div>
        )}
      </div>

      <Row className="g-0">
        <Col md={7} className={styles.leftColumn}>
          <Nav
            variant="pills"
            className={`mb-4 ${styles.innerTabs}`}
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
          >
            <Nav.Item>
              <Nav.Link eventKey="analytics">Web Analytics</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="tracked">Tracked Links</Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="position-relative mb-4">
            <h2 className={styles.title}>
              {current.titlePrefix} <br />
              <span className={styles.highlight}>{current.titleHighlight}</span>
            </h2>
            <img src="/assets/icons/Icon.svg" alt="Sparkles" className={styles.sparkles} />
          </div>

          <div className={styles.gifContainer}>
            <img src={current.gifSrc} alt="Feature Preview" className={styles.gifImage} />
          </div>
        </Col>

        <Col md={5} className={styles.rightColumn}>
          {/* Desktop Header */}
          <div className={`${styles.proHeader} d-none d-md-flex`}>
            <h3 className={styles.proTitle}>Unlock More features</h3>
            {onClose && (
              <div
                role="button"
                onClick={onClose}
                style={{ cursor: 'pointer' }}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') onClose()
                }}
              >
                <img src="/assets/icons/x-mark.svg" alt="Close" width="24" />
              </div>
            )}
          </div>

          <p className={styles.reasonsText}>{current.desc}</p>

          <div className={styles.featureList}>
            {current.features.map((feature, index) => (
              <div key={index} className={styles.featureItem}>
                <div className={styles.featureLeft}>
                  <img src={feature.icon} alt="" className={styles.featureIcon} />
                  <span>{feature.text}</span>
                </div>
                <img src="/assets/icons/checks.svg" alt="Included" className={styles.checkIcon} />
              </div>
            ))}
          </div>

          <Button className={styles.unlockButton} onClick={() => onUpgrade(activeTab)}>
            Unlock <img src="/assets/icons/arrow-right.svg" alt="" />
          </Button>
        </Col>
      </Row>
    </div>
  )
}

export default AnalyticsPaywall
